import React, { Component } from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import {setChannelList} from '../../actions';

import {Api, Time} from '../../util';

import Schedule from './Schedule';
import {Error} from '../../components/modal';

import Loading from '../../components/loading';

let TIMER;
class ContentContainer extends Component {
  constructor(props){
  super(props);
    this.state={
      total: [],
      errorContent: {},
      loadingToggle: false,
      toggleText: '자세한 정보 열기',
      toggleClass: 'modal-content',
      showModal: false,
      showError: false
    }
    this.handleHide = this.handleHide.bind(this);
  }
  handleHide() {
    this.setState({showModal: false});
  }

  componentWillReceiveProps (nextProps) {
    if(this.props.selectedDate !== nextProps.selectedDate){
      this.getEpgInfo(nextProps.selectedDate);
    }
  }

  componentWillMount(){
    this.getEpgInfo(this.props.selectedDate);  
  }

  async getEpgInfo(date = Time.getAddDate(Time.getToday(), -1)){
    this.setState({
      loadingToggle: true
    });
    try{
      // const epg = await Api.SearchEpg({date, urlYn: "Y"});       
      const epg = await Api.SearchEpgWShow({date, urlYn: "Y"}); 
      this.chListArray(epg.files);
      this.setState({
        showError: false
      });
    }catch(e){
      // NOTE: 스케줄이 없는 경우는 오류창을 띄우지 않는다.
      if(e.detail && !e.detail.includes('There is no broadcast schedule.')) {
        console.error(e);
        this.setState({
          showModal: true,
          errorContent: e
        });
      }
      this.setState({showError: true})

    } finally {
      this.setState({
        loadingToggle: false
      });
    }
  }

  async chListArray(req){
    const chInfo = (await Api.GetChList()).files;
    const epgCollection = req.prog;
    const totalList = {};

    const channelList = chInfo.ch
      .filter(ch => ch.use === 'Y')
      .map(ch => {
        const resolvedObj = {};
        // NOTE: epg 객체처럼 property 이름을 모두 소문자로 바꾼다
        _.keys(ch).forEach(propName => {
          resolvedObj[propName.toLowerCase()] = ch[propName];
        })
        return resolvedObj;
      });

    channelList.forEach(element => {
      totalList[element.chname] = [];
    })
    const realTime = moment().format('YYYYMMDDHHmm');
    epgCollection.forEach((data, index) => {
      
      if(totalList[data.chname]){
        const epgStart = data.start.slice(0,12);
        data.active = realTime >= epgStart;
        data.use = 'Y'; // NOTE: 채널 사용 여부
        totalList[data.chname].push(data);
      }
    })
    this.setState({
      total: Object.values(totalList)
    });
    this.props.setChannelList(channelList);
  }


  render() {
    const {
      loadingToggle,
      total,
      showModal,
      errorContent,
      showError,
    } = this.state;



    const {
      selectedMenu
    } = this.props;
    return (
      <div className='content'>
        {loadingToggle ? <Loading /> : null }
        <Schedule total={total} showError={showError}/>
        {showModal ? <Error 
          handleHide={this.handleHide}
          errorContent={errorContent}
        /> : null}
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    selectedDate: state.selectedDate,
    selectedMenu: state.selectedMenu
  }
};
const mapDispatcherToProps = dispatch => {
  return {
    setChannelList: (channelList) => dispatch(setChannelList(channelList))
  }
};

ContentContainer = connect(mapStateToProps, mapDispatcherToProps)(ContentContainer);

export default ContentContainer;



// WEBPACK FOOTER //
// ./src/containers/schedule/ContentContainer.js